import { startTransition, StrictMode } from "react";
import * as ReactDOM from "react-dom/client";
import { HydratedRouter } from "react-router/dom";

startTransition(() => {
  ReactDOM.hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter />
    </StrictMode>,
  );
});
